import { createFileRoute } from '@tanstack/react-router';

import { DemandDefinitionOverlay } from '../demand-definition/components/DemandDefinitionOverlay';

const EditDemandDefinitionRoute = () => {
    const { definitionId, substep } = Route.useParams();

    return <DemandDefinitionOverlay definitionId={definitionId} substep={substep} />;
};

export const Route = createFileRoute('/_app/demand-definitions/edit/$definitionId/$substep')({
    component: EditDemandDefinitionRoute,
});
